<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="待办订单">
        <need-to-do />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="已办订单">
        <complete />
      </rj-tab-pane>
      <rj-tab-pane v-if="hide" name="3" label="优选待办订单">
        <first-need-to-do />
      </rj-tab-pane>
      <rj-tab-pane v-if="hide" name="4" label="优选已办订单">
        <first-complete />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import needToDo from './needToDo';
import complete from './complete';
import firstNeedToDo from '@/views/distributor/order/first/firstNeedToDo';
import firstComplete from '@/views/distributor/order/first/firstComplete';
export default {
  name: 'ChiefOrderList',
  data () {
    return {
      hide: true
    };
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    needToDo,
    complete,
    firstNeedToDo,
    firstComplete
  },
  computed: {
    tabsActive: {
      get () {
        return this.$store.state.pagesTemporary.ChiefOrderListTabActive;
      },
      set (val) {
        this.$store.commit('pagesTemporary/SETChiefOrderListTabActive', val);
      }
    }
  },
  methods: {},
  mounted () {

  }
};
</script>
<style lang="scss"></style>
